import { FormDataStructure, FormState, State } from '../../../types'

export const RESET_FORM_DATA = 'form//RESET_FORM_DATA'
export const SAVE_FORM_DATA = 'form//SAVE_FORM_DATA'

export interface SaveFormDataAction {
  type: typeof SAVE_FORM_DATA
  payload: FormDataStructure
}

export interface ResetFormDataAction {
  type: typeof RESET_FORM_DATA
}

export type FormAction = SaveFormDataAction | ResetFormDataAction

export function saveFormData(data: FormDataStructure): SaveFormDataAction {
  return {
    type: SAVE_FORM_DATA,
    payload: data,
  }
}

export function resetFormData(): ResetFormDataAction {
  return {
    type: RESET_FORM_DATA,
  }
}

export function getFormData(store: State): FormDataStructure {
  return store.form.data
}

const initialState: FormState = {
  data: {} as FormDataStructure,
}

export default function formReducer(
  state: FormState = initialState,
  action: FormAction
): FormState {
  switch (action.type) {
    case RESET_FORM_DATA:
      return {
        ...state,
        data: {} as FormDataStructure,
      }

    case SAVE_FORM_DATA:
      return {
        ...state,
        data: action.payload,
      }

    default:
      return state
  }
}
